import { Component, input } from '@angular/core';
import { TextDirective } from '../../../../typography/text.directive';

@Component({
  selector: 'joii-week-day',
  imports: [TextDirective],
  template: `
    <abbr joii-text [size]="3" weight="semibold" [color]="'tint2'" [attr.title]="name() || null">{{ label() }}</abbr>
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    abbr {
      text-decoration: none;
    }
  `,
})
export class WeekDayComponent {
  label = input<string>('S');
  /** Full day name, exposed as the abbreviation's expansion (e.g. "Monday" for "Mon"). */
  name = input<string>('');
}
